/* Message.tsx
   Version: 1.1.0
   Date: 2020-12-12
*/

// eslint-disable-next-line
import React from 'react';

export interface MessageProps { 
    className?: string;
    classNameTextVisible?: string;
    classNameTextInvisible?: string;
    timeout?: number;
}

export interface MessageState { 
    message: string;
    visible: boolean;
}

export default class Message extends React.Component<MessageProps, MessageState> {

    private timer: number | undefined = undefined;

    constructor(props: MessageProps) {

        super(props);

        this.state = {
            message: '',
            visible: true,
        }

    }

    public render = (): JSX.Element => {

        return (
            <div className={this.props.className ?? 'basic-message'}>
                <span 
                    className={this.state.visible ? this.props.classNameTextVisible ?? 'basic-message-show' : this.props.classNameTextInvisible ?? 'basic-message-hide'} 
                    onTransitionEnd={this.onTransitionEnd} 
                    >{this.state.message}</span>
            </div>
        );

    }

    public setMessage = (newMessage: string | undefined): void => {

        // check if it is a new message and we must start the timer
        if (newMessage !== undefined && this.timer === undefined) {
            this.timer = window.setTimeout( (): void => this.fadeOut(), this.props.timeout ?? 3000);
            this.setState({ message: newMessage, visible: true });
        }
        // check if it is a new message and we must restart the timer
        else if (newMessage !== undefined && this.timer !== undefined) {
            window.clearTimeout(this.timer);
            this.timer = window.setTimeout( (): void => this.fadeOut(), this.props.timeout ?? 3000);
            this.setState({ message: newMessage, visible: true });
        }
        // check if we must stop the timer
        else if (newMessage === undefined && this.timer !== undefined) {
            window.clearTimeout(this.timer);
            this.setState({ message: '', visible: true });
        }

    }

    private onTransitionEnd = (): void => {
        this.setState({ message: '', visible: true });
    }

    private fadeOut = () => {
        this.setState({ visible: false });
    }

}
